<div [formGroup]="form">
    <select class="form-control" formControlName="partner">
        <option [value]="null">- Seleccionar -</option>
        <option *ngFor="let partner of listaPartner$ | async" [value]="partner.partnerNumber">{{partner.partnerNumber}} -
            {{partner.bussinessName}}</option>
    </select>
</div>